import type {ExtractionDiagnosticoFields} from './ExtractionDiagnosticoSection';
import {filledExtractedFieldsFirst, renderExtractedCard} from './DocTypeExtractedViewShared';

type ResidenciaDocTypeExtractedViewProps = {
    extractedData: unknown;
    diagnostico?: ExtractionDiagnosticoFields | null;
};

const RESIDENCIA_FIELDS = [
    {label: 'Nome do Titular', aliases: ['nome_titular', 'titular_nome']},
    {label: 'CPF/CNPJ do Titular', aliases: ['cpf_cnpj_titular', 'cpf_cnpj', 'cpfcnpj_titular']},
    {label: 'Endereço', aliases: ['endereco_completo', 'endereco', 'logradouro', 'street', 'address']},
    {label: 'Logradouro', aliases: ['logradouro', 'street']},
    {label: 'Número', aliases: ['numero', 'number']},
    {label: 'Complemento', aliases: ['complemento', 'address_complement']},
    {label: 'Bairro', aliases: ['bairro', 'district', 'neighborhood']},
    {label: 'Cidade', aliases: ['cidade', 'city']},
    {label: 'UF', aliases: ['uf', 'estado', 'state']},
    {label: 'CEP', aliases: ['cep', 'zipcode']},
    {label: 'Data do Documento', aliases: ['data_documento', 'issue_date', 'data_emissao']},
    {label: 'Mês Referência', aliases: ['periodo_referencia', 'mes_referencia', 'mesReferencia', 'competencia', 'reference_month', 'reference_date']}
] as const;

export function ResidenciaDocTypeExtractedView({
    extractedData,
    diagnostico
}: ResidenciaDocTypeExtractedViewProps) {
    return (
        <div className="space-y-2">
            {filledExtractedFieldsFirst(RESIDENCIA_FIELDS, extractedData).map((field) => renderExtractedCard(field, extractedData, diagnostico))}
        </div>
    );
}
